import React, { useEffect, useState } from 'react'
import { Box, Divider, Tab, Tabs, Grid, MenuItem, Pagination, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'

import Avatar from '@mui/material/Avatar'
import SwipeableViews from "react-swipeable-views";

import bag_grren from '../../assets/icons/myhealth/saline_bag_green.svg'
import bag_orange from '../../assets/icons/myhealth/saline_bag_orange.svg'
import heart from '../../assets/icons/myhealth/heart_red.svg'
import blood from '../../assets/icons/myhealth/blood_green.svg'
import wave_orange from '../../assets/icons/myhealth/wave_orange.svg'
import wave_green from '../../assets/icons/myhealth/wave_green.svg'
import wave_red from '../../assets/icons/myhealth/wave_red.svg'
import ruler from '../../assets/icons/myhealth/ruler.svg'
import bmi from '../../assets/icons/myhealth/graph_bmi.svg'

import AnnualHealthExaminationResults from "utils/components/annual-health-examination-results";
import Healthlink from "utils/components/healthlink";


import { useSelector } from 'react-redux';
import { getUser } from 'store/authSlice';
import { formatDate } from 'utils/function'

// TabPanel Component
function TabPanel({ children, value, index }) {
    return (
        <div role="tabpanel" hidden={value !== index}>
            {value === index &&
                <Box sx={{
                    p: 3,
                    "@media (max-width: 800px)": {
                        p: 0
                    },
                }}>{children}</Box>}
        </div>
    );
}


function MyHealth() {
    const [value, setValue] = useState(0);
    const user = useSelector(getUser);

    return (


        <Box sx={{ display: "grid", gridGap: "10px" }}>
            <Box sx={{ color: '#478F96', fontWeight: 600 }}>สุขภาพของฉัน</Box>

            <Box sx={{
                backgroundColor: '#EBF5FF',
                padding: '20px',
                display: 'grid',
                gridTemplateColumns: '1fr 4fr',
                gridGap: '40px',
                "@media (max-width: 800px)": {
                    gridTemplateColumns: '1fr',
                    gridGap: '10px',
                    padding: '10px'
                },
            }}>
                <Box sx={{ flex: 1 }}>
                    <Box sx={{
                        // width: '100%',
                        // height: '100%',
                        // backgroundColor: '#FFFFFF',
                        borderRadius: '10px',
                        // "@media (max-width: 1000px)": {
                        //     minHeight: '100px'
                        // },
                    }}>
                        <Box>
                            <Box
                                sx={{
                                    // width: '100%',
                                    // height: '100%',
                                    // backgroundColor: '#FFFFFF',
                                    borderRadius: '10px',
                                    display: 'flex',
                                    flexDirection: 'column', // Arrange content vertically
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    overflow: 'hidden', // Keeps content within the rounded box
                                    // "@media (max-width: 500px)": {
                                    //     minHeight: '160px',
                                    // },
                                }}
                            >
                                <Avatar
                                    sx={{
                                        width: '200px', // Size of the avatar
                                        height: '200px',
                                        borderRadius: '10px',
                                        "@media (max-width: 1000px)": {
                                            width: '150px',
                                            height: '150px',
                                        },
                                    }}
                                    alt={`${user['titlename']} ${user['firstname']} ${user['lastname']}`}
                                    src={user['image_url']}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box sx={{
                    display: 'grid',
                    gridGap: '10px',
                    flex: 1, // Added flex: 1 to take up remaining space
                    "@media (max-width: 800px)": {
                        fontSize: '14px'
                    }
                }}>
                    <Box sx={{ color: '#478F96', fontWeight: 600 }}>ข้อมูลส่วนตัว</Box>
                    <Box><span style={{ fontWeight: 600 }}>ชื่อ-สกุล :</span> <span>{user['titlename'] + ' ' + user['firstname'] + ' ' + user['lastname']}</span></Box>
                    <Box><span style={{ fontWeight: 600 }}>เพศ :</span> <span>{user['gender']}</span></Box>
                    {/* <Box><span style={{ fontWeight: 600 }}>วันเดือนปีเกิด :</span> <span>{formatDate(user['dob'])}</span></Box> */}
                    <Box><span style={{ fontWeight: 600 }}>เลขบัตรประชาชน :</span> <span>{user['card_id']}</span></Box>
                    <Box><span style={{ fontWeight: 600 }}>สังกัด :</span> <span>{user['department']?.['department_name']}</span></Box>
                </Box>
            </Box>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    padding: '0 5px',
                    flex: 1, // Added flex: 1 to ensure the container expands
                }}
            >
                <Tabs
                    value={value}
                    onChange={(event, newValue) => setValue(newValue)}
                    sx={{ p: "0px 5px" }}
                >
                    <Tab label="ผลการตรวจสุขภาพประจำปี" sx={{
                        fontWeight: 'bold',
                        color: '#478F96',
                        '&.Mui-selected': {
                            backgroundColor: '#A3D5D5', // Change color when selected
                            color: '#006D6D', // Change text color when selected
                        },
                    }} />
                    <Tab label="ข้อมูลสุขภาพจาก HealthLink" sx={{
                        fontWeight: 'bold',
                        color: '#478F96',
                        '&.Mui-selected': {
                            backgroundColor: '#A3D5D5', // Change color when selected
                            color: '#006D6D', // Change text color when selected
                        },
                    }} />
                </Tabs>
                <Divider />
                <SwipeableViews
                    index={value}
                    onChangeIndex={(index) => setValue(index)}
                >
                    <TabPanel value={value} index={0}>
                        <AnnualHealthExaminationResults />
                    </TabPanel>
                    <TabPanel value={value} index={1}>
                        <Healthlink />
                    </TabPanel>
                </SwipeableViews>
            </Box>
        </Box>

    )
}

export default MyHealth
